export class DeviationRowWidget {
  private readonly planInput: HTMLInputElement | null;
  private readonly factInput: HTMLInputElement | null;
  private readonly deviationInput: HTMLInputElement | null;

  constructor(private readonly root: HTMLElement) {
    this.planInput = root.querySelector<HTMLInputElement>('.plan-input');
    this.factInput = root.querySelector<HTMLInputElement>('.fact-input');
    this.deviationInput = root.querySelector<HTMLInputElement>('.deviation-input');
  }

  public init(): void {
    this.bindEvents();
    this.recalculate();
  }

  private bindEvents(): void {
    if (!this.planInput || !this.factInput) return;

    const handler = (): void => {
      this.recalculate();
    };

    this.planInput.addEventListener('input', handler);
    this.factInput.addEventListener('input', handler);
  }

  private recalculate = (): void => {
    if (!this.planInput || !this.factInput || !this.deviationInput) return;

    const planStr = this.planInput.value.trim();
    const factStr = this.factInput.value.trim();

    // Пустые поля → очищаем отклонение
    if (planStr === '' || factStr === '') {
      this.deviationInput.value = '';
      return;
    }

    const plan = Number(planStr);
    const fact = Number(factStr);

    // Проверка на NaN
    if (isNaN(plan) || isNaN(fact)) {
      this.deviationInput.value = '';
      return;
    }

    // если план = 0 и факт = 0 → отклонение = 0
    if (plan === 0 && fact === 0) {
      this.deviationInput.value = '0.00';
      return;
    }

    if (plan === 0) {
      this.deviationInput.value = '';
      return;
    }

    const deviation = ((fact - plan) / plan) * 100;
    this.deviationInput.value = deviation.toFixed(2);
  };
}
